import React, { useMemo } from 'react';
import moment from 'moment';
import { useQuery } from 'react-query';

import { Table } from '@raptormaps/table';

import { getFarmOrgsQuery } from '../../api/services/farm-orgs';

interface FarmPermissionsTableRow {
  orgName: string;
  grantedDate: string; // formatted date as string
  canEdit: string; // boolean as True or False
}

const columns: Array<{ key: keyof FarmPermissionsTableRow; name: string }> = [
  {
    key: 'orgName',
    name: 'Organization Name',
  },
  {
    key: 'grantedDate',
    name: 'Access Gained On',
  },
  {
    key: 'canEdit',
    name: 'Can Edit',
  },
];

interface FarmPermissionsTableProps {
  solarFarmId: number;
  solarFarmOrgId: number;
  orgNameMap: Map<number, string>;
}

export const FarmPermissionsTable = ({
  solarFarmId,
  solarFarmOrgId,
  orgNameMap,
}: FarmPermissionsTableProps) => {
  const { data, isLoading } = useQuery({
    ...getFarmOrgsQuery(solarFarmId, solarFarmOrgId),
    select: response => response.data,
  });

  const tableData = useMemo<Array<FarmPermissionsTableRow>>(() => {
    return (
      data?.map(entry => ({
        orgName: orgNameMap.get(entry.user_id) ?? entry.user_id.toString(),
        grantedDate: moment(entry.granted_at).format('MM/DD/YYYY'),
        canEdit: entry.role_id === 'editor' ? 'True' : 'False',
      })) ?? []
    );
  }, [data, orgNameMap]);

  return (
    <Table
      cols={columns}
      data={tableData ?? []}
      fetchData={() => Promise.resolve()}
      totalRowCount={tableData.length}
      fixedHeight={isLoading}
      tableHeight={800}
      hideControls
    />
  );
};
